<template>
  <div class="bg-white pt-4 pb-5 px-5 container-padding rounded-lg">
    <slot />
  </div>
</template>

<script setup lang="ts">
</script>
